import { Box, Grid, Typography, Theme } from '@mui/material';
import { InformationDialog, SubHeading } from '../investors/components';
import React, { useEffect, useState } from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import {
  applicantStatusMasters,
  ApplicationSourceMaster,
  ModeOfOprationMaster,
  ONBOARDING_INVESTOR,
  panCopyConsiderationDate,
  USER_ROLES,
  YesNoMaster,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import {
  AddMultiField,
  accreditedInvestorTypeCapture,
  USTaxableUSNonTaxableInvestorAccess,
  investorSubCategoryNRIorOCI,
  checkValidationBasedOnDate,
  doYouHavePanCopy,
  accreditedInvestorPresent,
} from '../../utils/utilityFunctions';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  mdmsAccridiatedInfoType,
  mdmsCountriesList,
  mdmsInvestorCategoryType,
  nationaliyType,
} from '../../redux-store/types/mdms';
import {
  getAccridiatedInfo,
  getInvestorCategory,
  getNationalityList,
} from '../../redux-store/actions';
export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
}: {
  title: string | undefined;
  description?: string[] | string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails> {description || description === 0 ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const {
    applicants = [],
    modeOfHolding,
    applicationSource,
    applicationType,
    createdAt = '',
  } = application;
  const dispatch = useDispatch();
  const [accridiatedInfo, setAccridiatedInfo] = useState<mdmsAccridiatedInfoType>(
    {} as mdmsAccridiatedInfoType
  );
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [mdmsInvestorType, setMdmsInvestorType] = useState<mdmsInvestorCategoryType>({});

  useEffect(() => {
    (async function () {
      try {
        // const nationalitiesMdmsMasters = (await dispatch(
        //   getNationalityList()
        // )) as unknown as nationaliyType;
        // setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        const categoryMasters = (await dispatch(
          getInvestorCategory()
        )) as unknown as mdmsInvestorCategoryType;
        setMdmsInvestorType(categoryMasters);
        const accridiatedInfoMasters = (await dispatch(
          getAccridiatedInfo()
        )) as unknown as mdmsAccridiatedInfoType;
        setAccridiatedInfo(accridiatedInfoMasters);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Operation:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {applicants.length > 1
                    ? ModeOfOprationMaster[application?.modeOfHolding || '']
                    : modeOfHolding || 'Single'}
                </Typography>
              </Typography>
              {/* {USER_ROLES.INVESTOR !== role && (
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Application Source:{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: 'rgba(0, 0, 0, 0.6)',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {applicationSource ? ApplicationSourceMaster[applicationSource] : 'N/A'}
                  </Typography>
                </Typography>
              )} */}
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              const [open, setOpen] = useState(false);
              const handleClose = () => {
                setOpen(false);
              };

              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'First Name'}
                        description={AddMultiField([applicant.namePrefix, applicant.firstName])}
                      />
                      <KeyValue title={'Middle Name'} description={applicant.middleName} />
                      <KeyValue title={'Last Name'} description={applicant.lastName} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue title={'Father Name'} description={applicant.fatherOrSpouseName} />
                      <KeyValue
                        title={'Investor Type'}
                        description={ONBOARDING_INVESTOR[applicationType]}
                      />
                      <KeyValue
                        title={'Investor Category'}
                        description={
                          mdmsInvestorType[applicant.investorCategory || '']?.displayText
                        }
                      />
                      <KeyValue
                        title={'Investor Sub-Category'}
                        description={
                          mdmsInvestorType[applicant.investorCategory || '']?.subCategory?.find(
                            (inv) => inv.key === applicant.investorSubCategory
                          )?.label
                        }
                      />

                      <KeyValue title={'Primary Tax Id'} description={applicant.taxIdNumber} />
                      {/* <KeyValue title={'Status'} description={applicant.status} /> */}
                      <KeyValue
                        title={'Country of Tax Residency'}
                        description={applicant.nationality}
                      />
                      <KeyValue
                        title={'Nationality of Applicant'}
                        description={applicant.countryNationality}
                      />
                      {investorSubCategoryNRIorOCI(applicant.investorSubCategory || '') &&
                        checkValidationBasedOnDate(createdAt, panCopyConsiderationDate) && (
                          <KeyValue
                            title={'Do you have a Pan Card?'}
                            description={YesNoMaster[applicant.panCardAvailable || '']}
                          />
                        )}
                      {doYouHavePanCopy(applicant.panCardAvailable || '') && (
                        <KeyValue title={'Pan Number'} description={applicant.panNumber} />
                      )}

                      {accreditedInvestorPresent(
                        applicant.investorCategory || '',
                        createdAt || ''
                      ) && (
                        <>
                          <Grid item xs={12} sm={12}>
                            <Item>Accredited Investor</Item>
                            <ItemDetails>
                              {YesNoMaster[applicant.isAccreditedInvestor || ''] || '-'}
                            </ItemDetails>
                            {accreditedInvestorTypeCapture(
                              applicant.isAccreditedInvestor || '',
                              applicant.investorCategory || ''
                            ) && (
                              <Item sx={{ pt: 0 }}>
                                {' '}
                                {accridiatedInfo[applicant.accreditedInvestorType || '']?.label ||
                                  ''}
                                {accridiatedInfo[applicant.accreditedInvestorType || '']?.info && (
                                  <Typography
                                    component="span"
                                    sx={{
                                      position: 'relative',
                                      left: 5,
                                      bottom: -5,
                                    }}>
                                    <InfoOutlinedIcon
                                      color="info"
                                      fontSize="small"
                                      onClick={() => setOpen(true)}
                                    />
                                  </Typography>
                                )}
                                <InformationDialog
                                  onClose={handleClose}
                                  open={open}
                                  content={
                                    accridiatedInfo[applicant.accreditedInvestorType || '']?.info ||
                                    ''
                                  }
                                  title={
                                    accridiatedInfo[applicant.accreditedInvestorType || '']
                                      ?.label || ''
                                  }
                                  infoIcon={false}
                                />
                              </Item>
                            )}
                          </Grid>
                        </>
                      )}

                      {/* {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )} */}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
            {/* {applicants.length > 1 && (
              <>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  Mode of Operation
                </SubHeading>
                <KeyValue
                  title={''}
                  description={ModeOfOprationMaster[application?.modeOfHolding || '']}
                />
              </>
            )} */}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
